import { render, staticRenderFns } from "./Definition.vue?vue&type=template&id=8b44fc6e&scoped=true"
import script from "./Definition.vue?vue&type=script&lang=js"
export * from "./Definition.vue?vue&type=script&lang=js"
import style0 from "./Definition.vue?vue&type=style&index=0&id=8b44fc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b44fc6e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DefinitionContent: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/Definition/DefinitionContent.vue').default})
